module.exports = __webpack_public_path__ + "images/promos/home-depot.jpg";